import { combineAttributeStrings } from '../../utils/internal';

import { heroHeaderId, heroImageId, heroSubheaderId } from './constants';
import { Terms, TermsWrapper } from './hero.styled';
import { HeroTermsProps } from './types';

export const HeroTerms: React.VFC<HeroTermsProps> = ({
  onClickTermsLink,
  reversed = false,
  termsLinkAs,
  termsLinkHref,
  termsLinkText,
  id,
}) => {
  return (
    <TermsWrapper $reversed={reversed} id={id}>
      *{' '}
      <Terms
        onClick={onClickTermsLink}
        {...(termsLinkHref && {
          as: termsLinkAs || 'a',
          ...(termsLinkAs ? { to: termsLinkHref } : { href: termsLinkHref }),
        })}
        aria-describedby={combineAttributeStrings(heroImageId, heroHeaderId, heroSubheaderId)}
      >
        {termsLinkText}
      </Terms>
    </TermsWrapper>
  );
};
